import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { FieldLabel } from './FieldLabel';
export const Select = ({ formField, formData, setFormData }) => (_jsxs(_Fragment, { children: [_jsx(FieldLabel, { formField: formField }, void 0), _jsx("select", Object.assign({ "data-testid": `form-field-${formField.id}`, required: formField.required, value: formField.id && formField.id in formData
                ? formData[formField.id]
                : '', onChange: (e) => setFormData({
                ...formData,
                [formField.id]: e.target.value,
            }) }, { children: formField.options &&
                formField.options.map((option, index) => (_jsx("option", Object.assign({ value: option.value }, { children: option.value }), index))) }), void 0)] }, void 0));
